import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Sets a specific slot in an image pack to a given image key. Unlike
// AddImageToPackCommand (which generates a key and assumes a fresh upload),
// this command takes an existing key — used by the image picker when the
// user chooses an asset that's already in `state.images` rather than
// uploading a new file.
export class SetImagePackSlotCommand extends CommandBase {
    packId: string;
    level: number;
    variation: number;
    imageKey: string;

    constructor(packId: string, level: number, variation: number, imageKey: string) {
        super();
        this.packId = packId;
        this.level = level;
        this.variation = variation;
        this.imageKey = imageKey;
    }

    execute(data: RemoteConstantsModel): boolean {
        const pack = data.imagePacks[this.packId];
        if (!pack) return false;

        // Pad with empty levels if needed (defensive — shouldn't happen in
        // normal flow since you open the picker from an existing slot).
        while (pack.length <= this.level) {
            pack.push([]);
        }

        const level = pack[this.level];
        if (this.variation < level.length) {
            if (level[this.variation] === this.imageKey) return false;
            level[this.variation] = this.imageKey;
        } else {
            level.push(this.imageKey);
        }
        return true;
    }
}
